import React from 'react';
import PropTypes from 'prop-types';
import fullName from 'utils/formatters/fullName';
import { useTranslation } from 'react-i18next';

function DriverInfoWindow(props) {
  const { t } = useTranslation();
  const equipment = props.driver.equipment_class
    ? t(props.driver.equipment_class.label)
    : '?';
  const phoneLink = `tel:${props.driver.phone}`;
  return (
    <div className="driver-jobs-popover">
      <p>
        <strong>{fullName(props.driver)}</strong>
      </p>
      {props.driver.phone && (
        <p>
          <i className="fa fa-phone" />
          <a href={phoneLink}>{props.driver.phone}</a>
        </p>
      )}
      {props.carrierName && <p>Carrier: {props.carrierName}</p>}
      <p>Truck Type: {equipment}</p>
    </div>
  );
}

DriverInfoWindow.propTypes = {
  driver: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    carrierName: PropTypes.string,
    equipment_class: PropTypes.shape({
      label: PropTypes.string,
    }),
    phone: PropTypes.string,
    jobs: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default DriverInfoWindow;
